import SubstepConfirmationModal from '../../../../SubstepConfirmationModal/SubstepConfirmationModal';

const ImportConfirmationModal = ({ isOpen, onClose, onMarkComplete, onSkip, isLoading }) => {
  return (
    <SubstepConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onMarkComplete={onMarkComplete}
      onSkip={onSkip}
      title="Continue without importing?"
      message="You haven't imported any data from your organization. You can continue without importing and come back later, or mark this step as complete if it doesn't apply to you."
      isLoading={isLoading}
    />
  );
};

export default ImportConfirmationModal;
